<template>
  <section id="section-lead-information">
    <h2 id="h2-lead-information">Enter Details</h2>
    <v-form
        id="information-block"
        v-model="valid"
    >
      <v-text-field
          class="input-label-star-red"
          v-model="leadInfo.firstName"
          label="First Name"
          outlined
          clearable
          :rules="rulesRequired"
          validate-on-blur
      ></v-text-field>
      <v-text-field
          class="input-label-star-red"
          v-model="leadInfo.lastName"
          label="Last Name"
          outlined
          clearable
          :rules="rulesRequired"
          validate-on-blur
      ></v-text-field>
      <v-text-field
          class="input-label-star-red"
          v-model="leadInfo.email"
          label="Email"
          outlined
          clearable
          :rules="rulesEmail"
          validate-on-blur
      ></v-text-field>
      <v-text-field
          class="input-label-star-red"
          v-model="leadInfo.phone"
          label="Phone"
          outlined
          clearable
          :rules="rulesRequired"
          validate-on-blur
      ></v-text-field>
      <v-textarea
          v-model="meetingDescription"
          outlined
          label="Please share anything that will help prepare for our meeting"
      ></v-textarea>
      <v-btn
          id="button-submit"
          color="blue"
          :dark="valid"
          @click="actionConfirm"
          :disabled="!valid"
      >
        SUBMIT
      </v-btn>
    </v-form>
  </section>
</template>

<script>
import moment from 'moment-timezone'
export default {
  name: "leadInformation",
  data(){
    return {
      leadInfo: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null
      },

      meetingDescription: null,
      rulesRequired: [function(value) {
        return !!value || "Field is required.";
      }],
      rulesEmail: [function(value) {
        return !!value || "Field is required";
      }, function(checkEmail) {
        return /.+@.+\..+/.test(checkEmail) || "E-mail must be valid";
      }],
      valid: false
    }
  },
  methods: {
    async actionConfirm(){

      this.$store.commit("set_descriptionMeeting", this.meetingDescription);
      const dataConfirm={
        hash : this.$store.getters.hash,
        meeting_id : this.$store.getters.idMeeting,
        firstName : this.leadInfo.firstName,
        lastName : this.leadInfo.lastName,
        email : this.leadInfo.email,
        phone : this.leadInfo.phone,
        description : this.meetingDescription,
        date : moment(this.$store.getters.dateBooking).utcOffset(this.$store.getters.timeZoneLead).format("YYYY-MM-DD"),
        time : moment(this.$store.getters.dateBooking).utcOffset(this.$store.getters.timeZoneLead).format("HH:mm")
      }
      this.$root.$emit("loadingTrue");
      // eslint-disable-next-line no-unused-vars
      const resSchedule = await this.$store.dispatch("set_confirm", dataConfirm);
      this.$root.$emit("loadingFalse");

 //     this.$parent.$emit('actionConfirm', dataConfirm);

      this.$root.$emit("confirmed");
    },
  }
}
</script>

<style scoped>
  #section-lead-information{
    margin-top: -20px;
  }
  #h2-lead-information{
    font-size: 1.2rem;
  }
  .input-lead-info .v-label:after{
    color:red;
    content:"*";
  }
</style>